import styled from '@emotion/styled';
import { theme } from '@travelnest/hui';
import * as React from 'react';
import { InfoCard } from '../info-card/InfoCard';
import StyledHeading from '../typography/StyledHeading';
import StyledText from '../typography/StyledText';

const CardContainer = styled(InfoCard)`
	background-color: ${theme.colors.GR20T};
	justify-content: flex-start;
`;

const Title = styled(StyledHeading)`
	color: ${theme.colors.GR200};
	margin: 0 0 11px 0;
`;

const VerificationInfoContainer = styled.div`
	align-self: flex-start;
	justify-self: flex-start;
`;

const StyledParagraph = styled(StyledText)`
	color: ${theme.colors.GR200};
	margin: 0 0 11px 0;
	opacity: 70%;
`;

const StyledParagraphFinal = styled(StyledParagraph)`
	margin: 0;
`;

interface IGoLiveInfoCard {
	title: string;
}

export const VerificationCard: React.FC<IGoLiveInfoCard> = ({ title }) => (
	<CardContainer data-testid="card-awaiting-verification">
		<Title type="IB110" lineHeight="sm" htmlElement="h4">
			✅ {title}
		</Title>
		<VerificationInfoContainer>
			<StyledParagraph type="IR100" lineHeight="md">
				Before your property goes live we need to do some verification on your identity. This is both for the safety of our hosts and their guests.
			</StyledParagraph>
			<StyledParagraph type="IR100" lineHeight="md">
				This can take <strong>up to 72 hours.</strong> We might get in touch for some extra details.
			</StyledParagraph>
			<StyledParagraphFinal type="IR100" lineHeight="md">
				Once complete we’ll share your property with your chosen channels.
				It can take <strong>up to 14 days</strong> for them to show up ready for bookings.
			</StyledParagraphFinal>
		</VerificationInfoContainer>
	</CardContainer>
);
